import React, { Component } from 'react';
import Box from 'grommet/components/Box';
import { connect } from 'react-redux';
import Table from 'grommet/components/Table';
import TableRow from 'grommet/components/TableRow';
import Article from 'grommet/components/Article';
import TextInput from 'grommet/components/TextInput';
import CheckBox from 'grommet/components/CheckBox';
import Label from 'grommet/components/Label';
import Paragraph from 'grommet/components/Paragraph';
import {updateCalculations,cleanupGrowth, updateFinishButton} from '../commonLogic';
import { toggleSizeButton } from '../../State/actions/sessions';
import * as Constants from '../Redux/action_types/EPAConstants.js';
import Layer from 'grommet/components/Layer';
import Spinning from 'grommet/components/icons/Spinning';
import Heading from 'grommet/components/Heading';
import Warning from './Warning';
class Growth extends Component {
    constructor() {
        super();
        this.state = {
            DisplayNote: true,
        };

    }

    componentDidUpdate(previousProps){
        if(this.props.defaultSizerWorkload.GatewayQty !== previousProps.defaultSizerWorkload.GatewayQty){
            !isNaN(this.props.defaultSizerWorkload.GatewayQty) ?  this.state.DisplayNote = false : this.state.DisplayNote = true;

            this.setState({});
        }
        
    }
    componentDidMount() {
        if (this.props.workload.UserInputs.Environments.Growth === undefined) {
            this.props.workload.UserInputs.Environments['Growth'] = this.props.defaultWorkload.UserInputs.Environments.Growth;
        }
        let getObject;
        let nodesCount;

        cleanupGrowth(this.props.workload);

        if (this.props.workload.UserInputs.Environments.WorkloadType === Constants.BIG_DATA) {
            this.props.workload.UserInputs.Environments.Functions.Function.forEach(x => {
                if (Array.isArray(x.Service)) {
                    x.Service.filter(elem => elem["@Selected"] == "true").forEach(filteredItem => {
                        getObject = this.props.workload.UserInputs.Environments['Growth'].Service.find(item => item['@Service'] === filteredItem['@Type']);
                        nodesCount = filteredItem.Hardware["@NodesCount"];
                        this.updateObject(getObject, x["@Type"], filteredItem["@Type"], nodesCount);
                    })
                }
                else {
                    if (x.Service["@Selected"] == "true" && x["@Type"] !== "Gateway Node" && x["@Type"] !== "Master Node") {
                        getObject = this.props.workload.UserInputs.Environments['Growth'].Service.find(item => item['@Service'] === x.Service['@Type']);
                        nodesCount = x.Service.Hardware["@NodesCount"];
                        this.updateObject(getObject, x["@Type"], x.Service['@Type'], nodesCount);
    
                    } else if ( x.Service["@Selected"]==="true" && x["@Type"] === "Master Node") {
                        getObject = this.props.workload.UserInputs.Environments['Growth'].Service.find(item => item['@Name'] === x['@Type']);
                        nodesCount = x.Service.Hardware["@NodesCount"];
                        this.updateObject(getObject, x["@Type"], "", nodesCount);
                    } else if(x.Service["@Selected"]==="true" && x["@Type"] === "Gateway Node" && isNaN(x.Service.Hardware["@NodesCount"])){
                                this.state.DisplayNote = true;                        
                    } else if(x.Service["@Selected"]==="true" && x["@Type"] === "Gateway Node" && !isNaN(x.Service.Hardware["@NodesCount"])){
                        getObject = this.props.workload.UserInputs.Environments['Growth'].Service.find(item => item['@Name'] === x['@Type']);
                                nodesCount = x.Service.Hardware["@NodesCount"];
                                this.state.DisplayNote = false;
                            this.updateObject(getObject, x["@Type"], "", nodesCount);
                        }               
                }
            })
        } else {
            this.props.workload.UserInputs.Environments.Environment.filter(solution => solution["@isSelected"] === Constants.yES_).map(selectedSolution => {
                selectedSolution.Templates.ServerDetails.Server.map(role => {
                    if (role["@NodesCount"] !== "0") {
                        getObject = this.props.workload.UserInputs.Environments.Growth.Host.find(serviceRole => serviceRole["@SolutionType"] === selectedSolution["@SolutionType"] && serviceRole["@RoleName"] === role["@RoleName"]);
                        nodesCount = role["@NodesCount"];
                        this.updateObject(getObject, selectedSolution["@SolutionType"], role["@RoleName"], nodesCount);
                    }
                })
            })
            if (updateFinishButton(this.props.workload, this.props.displayWarning, this.props.activeSession.isSizeEnabled)) {
                this.props.OnToggleSizeButton(true);
            }
        }
        
        this.setState({});
    }

    removeObject = (itemToRemove, isService) => {
        let rest;
        isService ?
            rest = this.props.workload.UserInputs.Environments['Growth'].Service.filter(item => item['@Service'] !== itemToRemove)
            :
            rest = this.props.workload.UserInputs.Environments['Growth'].Service.filter(item => item['@Name'] !== itemToRemove);

        this.props.workload.UserInputs.Environments['Growth'].Service = rest;
    }

    updateObject = (getObject, functionName, service, nodesCount) => {
        if (!getObject) {
            let item = {};
            if (this.props.workload.UserInputs.Environments.WorkloadType === Constants.BIG_DATA) {
                item['@Name'] = functionName;
                item['@Service'] = service;
                item['@GrowthType'] = 'Nodes';
                item['@GrowthRate'] = '0';
                item['@Nodes1Y'] = nodesCount;
                item['@Nodes2Y'] = "";
                item['@Nodes3Y'] = "";
                this.props.workload.UserInputs.Environments['Growth'].Service.push({ ...item });
            } else {
                item["@GrowthRate"] = "0";
                item["@Nodes1Y"] = nodesCount;
                item["@Nodes2Y"] = "-";
                item["@Nodes3Y"] = "-";
                item["@Nodes4Y"] = "-";
                item["@RoleName"] = service;
                item["@SolutionType"] = functionName;
                this.props.workload.UserInputs.Environments.Growth.Host.push({ ...item });
            }  
        }
        else {            
            if(getObject['@Nodes1Y'] !== nodesCount) {
                getObject['@Nodes1Y'] = nodesCount.toString();            
                updateCalculations(getObject, this.props.workload);    
            }        
        }

    }


    OnvalueChange(e, functionName, serviceName, changeType) {
        let itemToUpdate;
	let maxValue;
        if (changeType === "Blur") {
            if (e.target.value === "") {
                e.target.value = "0";
            }
        }
        if (this.props.workload.UserInputs.Environments.WorkloadType === Constants.BIG_DATA) {
            itemToUpdate = this.props.workload.UserInputs.Environments.Growth.Service.find(item => item["@Service"] === serviceName);
            if (!itemToUpdate) {
                itemToUpdate = this.props.workload.UserInputs.Environments.Growth.Service.find(item => item["@Name"] === functionName);
            }
             maxValue = itemToUpdate["@GrowthType"] === "Percentage" ? 500 : 99;
            if ((!isNaN(parseInt(e.target.value, 10))) && parseInt(e.target.value, 10) <= maxValue) {
                itemToUpdate["@GrowthRate"] = parseInt(e.target.value, 10);
                updateCalculations(itemToUpdate, this.props.workload);
            } else {
                if (e.target.value == "") {
                    itemToUpdate["@GrowthRate"] = "";
                }
            }
        } else {
	     maxValue = 100;
            if (serviceName === Constants.CONTROLLER_HOST || serviceName === Constants.GATEWAY_HOST) {
                itemToUpdate = this.props.workload.UserInputs.Environments.Growth.Host.find(item => item["@SolutionType"] === serviceName);
                if (!itemToUpdate) {
                    itemToUpdate = this.props.workload.UserInputs.Environments.Growth.Host.find(item => item["@SolutionType"] === serviceName);
                }
            }
            else {
                itemToUpdate = this.props.workload.UserInputs.Environments.Growth.Host.find(item => `${item["@SolutionType"]}-${item["@RoleName"]}` === serviceName);
                if (!itemToUpdate) {
                    itemToUpdate = this.props.workload.UserInputs.Environments.Growth.Host.find(item => `${item["@SolutionType"]}-${item["@RoleName"]}` === serviceName);
                }
            }
	}
            if ((!isNaN(parseInt(e.target.value, 10))) && parseInt(e.target.value, 10) <= maxValue) {
                itemToUpdate["@GrowthRate"] = e.target.value;
                updateCalculations(itemToUpdate, this.props.workload);
            } else {
                if (e.target.value == "") {
                    itemToUpdate["@GrowthRate"] = "";
                }
            }
        this.setState({})
    }


    ChkboxChange(functionName, serviceName, change) {
        let itemToUpdate = this.props.workload.UserInputs.Environments.Growth.Service.find(item => item["@Service"] === serviceName);
        if (!itemToUpdate) {
            itemToUpdate = this.props.workload.UserInputs.Environments.Growth.Service.find(item => item["@Name"] === functionName);
        }

        itemToUpdate["@GrowthType"] = change ? "Percentage" : "Nodes";
        if (itemToUpdate["@GrowthRate"] === 500 && itemToUpdate["@GrowthType"] !== "Percentage") {
        	itemToUpdate["@GrowthRate"] = 99;
        }
        updateCalculations(itemToUpdate, this.props.workload);
        this.setState({})
    }

    createRow = (filteredItem) => {
        //(isNaN(this.props.defaultSizerWorkload.GatewayQty) || this.props.defaultSizerWorkload.GatewayQty === null)
        let filteredItemType;
        if (this.props.workload.UserInputs.Environments.WorkloadType === Constants.BIG_DATA) {
            if (!(filteredItem["@Name"] == Constants.GATEWAY_NODE && isNaN(this.props.workload.UserInputs.Environments.Functions.Function.find(service => service["@Type"] === Constants.GATEWAY_NODE).Service.Hardware["@NodesCount"]))) {
                filteredItemType = filteredItem["@Service"] ? filteredItem["@Service"] : filteredItem["@Name"];
            } 
        } else {
            filteredItemType = filteredItem["@RoleName"] ? `${filteredItem["@SolutionType"]}-${filteredItem["@RoleName"]}` : filteredItem["@SolutionType"];
        }
            
        return <TableRow>
            <td>
                {filteredItemType}
            </td>
            <td>
                <TextInput style={{width:'38%'}} id='item1' value={filteredItem["@GrowthRate"]} onDOMChange={(e) => this.OnvalueChange(e, filteredItem["@Name"], filteredItemType, "Change")} onBlur={(e) => this.OnvalueChange(e, filteredItem["@Name"], filteredItemType, "Blur")} />
            </td>
            {this.props.workload.UserInputs.Environments.WorkloadType === Constants.BIG_DATA ?
                <td className='secondary'>
                    <CheckBox checked={filteredItem["@GrowthType"] === "Percentage" ? true : false} onChange={(e) => { this.ChkboxChange(filteredItem["@Name"], filteredItemType, e.target.checked) }} />
                </td> : '' 
            }
            <td>
                <Label style={{marginLeft:'30%'}}>{filteredItem["@Nodes1Y"]}</Label>
            </td>
            <td>
                <Label style={{marginLeft:'30%'}}>{filteredItem["@Nodes2Y"]}</Label>
            </td>
            <td className='secondary'>
                <Label style={{marginLeft:'30%'}}>{filteredItem["@Nodes3Y"]}</Label>
            </td>
	    {this.props.workload.UserInputs.Environments.WorkloadType === "BlueData" ?
                    <td className='secondary'>
                        <Label style={{ marginLeft: '30%' }}>{filteredItem["@Nodes4Y"]}</Label>
                    </td> : ''}
        </TableRow>
  }

    updateNode2yrNode3yr = () => {
        let hyphen = "-";
        let servicewithNonZeroGrowth;
        if (this.props.workload.UserInputs.Environments.WorkloadType === "BigData") {
            servicewithNonZeroGrowth = this.props.workload.UserInputs.Environments['Growth'].Service.find(service => service["@GrowthRate"] != "0")
        } else {
            if (Array.isArray(this.props.workload.UserInputs.Environments['Growth'].Host)) {
                servicewithNonZeroGrowth = this.props.workload.UserInputs.Environments['Growth'].Host.find(service => service["@GrowthRate"] != "0");
            } else {
                servicewithNonZeroGrowth = this.props.workload.UserInputs.Environments['Growth'].Host["@GrowthRate"] != "0";
            }
        }
        if (servicewithNonZeroGrowth) {
            if (this.props.workload.UserInputs.Environments.WorkloadType === "BigData") {
                this.props.workload.UserInputs.Environments['Growth'].Service.map(service => {
                    if (service["@GrowthRate"] == "0") {
                        service["@Nodes2Y"] = service["@Nodes1Y"];
                        service["@Nodes3Y"] = service["@Nodes1Y"];
                    }
                })
            } else {
                if (Array.isArray(this.props.workload.UserInputs.Environments['Growth'].Host)) {
                    this.props.workload.UserInputs.Environments['Growth'].Host.map(service => {
                        if (service["@GrowthRate"] == "0") {
                            service["@Nodes2Y"] = service["@Nodes1Y"];
                            service["@Nodes3Y"] = service["@Nodes1Y"];
                            service["@Nodes4Y"] = service["@Nodes1Y"];
                        }
                    })
                } else {
                    let service = this.props.workload.UserInputs.Environments['Growth'].Host
                    if (service["@GrowthRate"] == "0") {
                        service["@Nodes2Y"] = service["@Nodes1Y"];
                        service["@Nodes3Y"] = service["@Nodes1Y"];
                        service["@Nodes4Y"] = service["@Nodes1Y"];
                    }
                }
            }
        } else {
            if (this.props.workload.UserInputs.Environments.WorkloadType === "BigData") {
                this.props.workload.UserInputs.Environments['Growth'].Service.map(service => {
                    service["@Nodes2Y"] = hyphen;
                    service["@Nodes3Y"] = hyphen;
                })
            } else {
                if (Array.isArray(this.props.workload.UserInputs.Environments['Growth'].Host)) {
                    this.props.workload.UserInputs.Environments['Growth'].Host.map(service => {
                        service["@Nodes2Y"] = hyphen;
                        service["@Nodes3Y"] = hyphen;
                        service["@Nodes4Y"] = hyphen;
                    })
                } else {
                    let service = this.props.workload.UserInputs.Environments['Growth'].Host;
                    service["@Nodes2Y"] = hyphen;
                    service["@Nodes3Y"] = hyphen;
                    service["@Nodes4Y"] = hyphen;
                }
                
            }
        }
    }


    render() {
        var note=''
        let headings = Constants.EPA_GROWTH_HEADINGS;
        if(this.state.DisplayNote && this.props.workload.UserInputs.Environments.WorkloadType === "BigData"){
            note =<Paragraph> <b>Note : </b>  Gateway Node will be added as "{this.props.workload.UserInputs.Environments.Functions.Function.find(service => service["@Type"] === Constants.GATEWAY_NODE).Service.Hardware["@NodesCount"]}" for 2nd and 3rd Year Growth solutions. </Paragraph>
        }
        else{
             note=''
            if (this.props.workload.UserInputs.Environments.WorkloadType === Constants.BLUE_DATA) {
            headings = Constants.EZMERAL_GROWTH_HEADINGS;
            }
        }
        var LoadindData = '';
    if (this.props.defaultSizerWorkload.isLoading) {
      LoadindData = <Layer style={{ zIndex: '500 !important' }}>
        <Box direction='row' style={{ padding: '40px', backgroundColor: "#425563" }} size='medium' pad={{ 'between': 'small' }}>
          <Spinning className="Spinning" size='small' />
          <Heading tag='h5' margin='none' style={{ color: "#fff" }}>Loading... Please Wait</Heading>
        </Box>
      </Layer>
    }
    var getObj;
    var nodecount
        if (this.props.workload.UserInputs.Environments.WorkloadType === "BigData" && this.props.workload.UserInputs.Environments['Growth']) {
            this.props.workload.UserInputs.Environments.Functions.Function.forEach(x => {
                if (!Array.isArray(x.Service) && x.Service["@Selected"] === "true" && x["@Type"] === "Gateway Node" && !isNaN(this.props.workload.UserInputs.Environments.Functions.Function.find(service => service["@Type"] === Constants.GATEWAY_NODE).Service.Hardware["@NodesCount"])) {
                    getObj = this.props.workload.UserInputs.Environments['Growth'].Service.find(item => item['@Name'] === x['@Type']);
                    nodecount = x.Service.Hardware["@NodesCount"];
                    this.state.DisplayNote = false;
                    this.updateObject(getObj, x["@Type"], "", nodecount);
                }
                else if (x.Service["@Selected"] === "true" && x["@Type"] === "Gateway Node" && isNaN(x.Service.Hardware["@NodesCount"])) {
                    getObj = this.props.workload.UserInputs.Environments['Growth'].Service.find(item => item['@Name'] === x['@Type']);
                    if (getObj) {
                        this.removeObject(getObj['@Name'], false);
                    }
                }
            })
        }
        let content
        this.updateNode2yrNode3yr();
        if (this.props.workload.UserInputs.Environments.WorkloadType === "BigData") {
            content = this.props.workload.UserInputs.Environments.Growth && this.props.workload.UserInputs.Environments.Growth.Service.map(x => {
                return this.createRow(x);
            })
        }
        if (this.props.workload.UserInputs.Environments.WorkloadType === "BlueData") {
            if (this.props.workload.UserInputs.Environments.Growth) {
                if (Array.isArray(this.props.workload.UserInputs.Environments.Growth.Host)) {
                    content = this.props.workload.UserInputs.Environments.Growth.Host.map(x => {
                        if(x["@SolutionType"] !== Constants.GATEWAY_HOST && x['@SolutionType'] !== Constants.CONTROLLER_HOST && x["@RoleName"] !== '' && x["@SolutionType"] !== ''){
                            return this.createRow(x);
                        }
                    })
                } else {
                    content = this.createRow(this.props.workload.UserInputs.Environments.Growth.Host);
                }
            }
        }
        return (
            <Box pad='small' margin='none' style={{ position: 'relative', width: '100%' }}>
                {LoadindData}
                <Article id="scroll" full={true} margin="none" pad={{ between: 'small' }} style={{ maxHeight: '95%' }} justify='between' >
                    <Box className='GrowthTable' margin="none" pad={{ between: 'small' }} style={{ marginRight: '10px' }}>
                        <Box margin="none" pad="small" style={{ padding: '0px' }} >
                            <Warning message={Constants.HPECP_WARNING_MESSAGE} isEnabled={!this.props.displayWarning} history={this.props.history}/>
                            <Table >
                                <thead>
                                    <tr>
                                        {
                                            headings.map(item =>
                                                <th style={{ fontWeight: '600' }}>
                                                    {item}
                                                </th>
                                            )
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {content}
                                </tbody>
                            </Table>
                            {note}
                        </Box>
                    </Box>
                </Article>

            </Box>

        );

    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        OnToggleSizeButton: (value) => { dispatch(toggleSizeButton(value)) }
    }
}
const mapStateToProps = (state) => {
    return {
        workload: state.sizerWorkload.workload,
        activeSession: state.sessions.activeSession,
        defaultWorkload: state.sessions.sessionDefaults.workload,
        defaultSizerWorkload: state.sizerWorkload,
        ConfigButton: state.sizerWorkload.calbtn,
        displayWarning: state.sizerWorkload.guiState.displayWarning
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Growth);



// WEBPACK FOOTER //
// ./src/SizerUI/SizerScreens/Growth.js